import { TweenLite } from 'gsap';
import { Expo } from 'gsap/gsap-core';

class SingleNavigation {
	constructor() {
		this.scrollDistanceToSticky = 30;

		this.navigation = document.querySelector('.single-navigation');
		if (this.navigation) {
			this.navigationLinks = this.navigation.querySelectorAll('span');

			this.addStickyOnScroll();
			this.toggleNavigation();
		}
	}

	addStickyOnScroll = () => window.addEventListener('scroll', this.toggleNavigation);

	toggleNavigation = () => {
		if (this.isSticky() && !this.navigationHidden) {
			this.hideNavigation();
			this.navigationHidden = true;
		} else if (!this.isSticky() && this.navigationHidden) {
			this.showNavigation();
			this.navigationHidden = false;
		}
	};

	hideNavigation = () =>
		TweenLite.fromTo(
			this.navigationLinks,
			0.4,
			{ y: 0, autoAlpha: 1 },
			{ y: '-150%', autoAlpha: 0, ease: Expo.easeOut }
		);
	showNavigation = () =>
		TweenLite.fromTo(
			this.navigationLinks,
			0.4,
			{ y: '-150%', autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, ease: Expo.easeOut }
		);

	isSticky = () => window.pageYOffset > this.scrollDistanceToSticky;
}

export default SingleNavigation;
